var Marionette = require('marionette');
require('backbone.babysitter');

// TODO: could just MonitorDOMRefresh for onShow ability

module.exports = Marionette.ItemView.extend({

   constructor: function() {
       this.createChildren();
       return Marionette.ItemView.prototype.constructor.apply(this, arguments);
   },

    /* extra to be used as mixin */
   createChildren: function() {
        this.children = new Backbone.ChildViewContainer();
   },

   onBeforeDestroy: function() {
        var children = this.children;
            children.each(function(c) {
            c.destroy();
            children.remove(c);
        });
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/common/BabySitterView.js
 ** module id = 489
 ** module chunks = 0
 **/